import styled from 'styled-components';
import { Link } from 'react-router-dom';

//Link principal header
const LinkPricipalHeader = styled(Link)`
    width: auto; 
    color: #333;
    font-family: Dosis;
    height: auto; 
    display: flex;
    flex-direction: row;
    margin: 0px 40px 0px 0px;
    font-size: 1.0rem; 
    font-weight: 50;

    cursor: pointer;
    text-decoration: none;
    font-size: 15px;
    outline: none;
    font-weight: 400;
    position: relative; 
    transition: color 0.3s ease; 

    &:hover {
        color: white;
        span:after {
            content: '';
            position: absolute;
            bottom: -2px; 
            left: 0;
            width: 0; 
            height: 2px; 
            background-color: white;
            animation: growWidth 0.3s forwards; 
        }
    }

    @keyframes growWidth {
        from {
            width: 0; 
        }
        to {
            width: 100%; 
        }
    }
`;

export default LinkPricipalHeader;
